export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8714.5977a3f8.jpg";